import { COLOR_TABLE } from '../../../constants';
import type { TextColor } from '../../../types';
import type {
    FeatureBanner as FeatureBannerEntry,
    ImageFields,
    VideoFields,
} from '../../../types/spaces/ecommerce-petsmart';
import { isResolvedLinkEntry } from '../../../utils/isResolvedLinkEntry';
import { getImageProps } from '../../../utils/propsImagesItems';
import type { FeatureBannerProps } from './types';

export function transformFeatureBanner(
    entry: FeatureBannerEntry,
    { headingTagName = 'h2' }: Partial<Pick<FeatureBannerProps, 'headingTagName'>> = {}
): FeatureBannerProps | null {
    const { header, description, cta, media, textColor, backgroundColor } = entry.fields;
    if (!isResolvedLinkEntry(media)) return null;
    const link = isResolvedLinkEntry(cta) && isResolvedLinkEntry(cta.fields.link) ? cta.fields.link : undefined;
    // The SDK collapses linked skeleton unions to their shared fields.
    const mediaFields = media.fields as ImageFields | VideoFields;

    return {
        header,
        description,
        headingTagName,
        color: textColor && COLOR_TABLE[textColor as TextColor],
        backgroundColor,
        media:
            'remoteVideoUrl' in mediaFields
                ? {
                      type: 'video',
                      url: mediaFields.remoteVideoUrl,
                      autoplay: mediaFields.isVideoAutoplay,
                      loop: mediaFields.isVideoLooped,
                  }
                : { type: 'image', ...toImage(mediaFields) },
        cta:
            isResolvedLinkEntry(cta) && link
                ? {
                      label: cta.fields.text,
                      href: link.fields.webUrl,
                      target: cta.fields.behavior === 'New Tab' ? '_blank' : '_self',
                      variant: cta.fields.buttonStyle === 'Primary' ? 'primary' : 'table-header',
                  }
                : undefined,
    };
}

function toImage(image: Parameters<typeof getImageProps>[0]) {
    const { items, imgSrc, imgAlt } = getImageProps(image);

    return { items, src: imgSrc, alt: imgAlt };
}
